module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1099-retro.a4a8ed8d.jpg";